// All User Type Options (matching backend USER_TYPES)
export const ALL_USER_TYPE_OPTIONS = [
  { label: 'Master Admin', value: 'MASTER_ADMIN' },
  { label: 'Admin', value: 'ADMIN' },
  { label: 'Sub Admin', value: 'SUB_ADMIN' },
  { label: 'Doctor', value: 'DOCTOR' },
  { label: 'Manager', value: 'MANAGER' },
  { label: 'Therapist', value: 'THERAPIST' },
  { label: 'Counsellor', value: 'COUNSELLOR' },
  { label: 'Receptionist', value: 'RECEPTIONIST' },
  { label: 'Accountant', value: 'ACCOUNTANT' },
  { label: 'Marketing', value: 'MARKETING' },
] as const;

// Function to get user type options based on current user's role
export const getUserTypeOptions = (currentUserType?: string) => {
  switch (currentUserType) {
    case 'MASTER_ADMIN':
      // Master Admin can create all user types
      return ALL_USER_TYPE_OPTIONS;
  
    default:
      // Admin can create most user types except Master Admin
      return ALL_USER_TYPE_OPTIONS.filter(option => option.value !== 'MASTER_ADMIN');
  }
};

// Backward compatibility - default export
export const USER_TYPE_OPTIONS = ALL_USER_TYPE_OPTIONS;

// User Status Options (matching backend USER_STATUSES)
export const USER_STATUS_OPTIONS = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Resigned', value: 'RESIGNED' },
  { label: 'Inactive', value: 'INACTIVE' },
] as const;

// Function to get filter options for table based on current user's role
export const getUserTypeFilterOptions = (currentUserType?: string) => {
  return getUserTypeOptions(currentUserType).map(option => ({
    text: option.label,
    value: option.value,
  }));
};

// Filter options for table (backward compatibility)
export const USER_TYPE_FILTER_OPTIONS = USER_TYPE_OPTIONS.map(option => ({
  text: option.label,
  value: option.value,
}));

export const USER_STATUS_FILTER_OPTIONS = USER_STATUS_OPTIONS.map(option => ({
  text: option.label,
  value: option.value,
}));
